__turbopack_context__.v({
  "copy": "ekO5ga_copy",
  "disclaimerSection": "ekO5ga_disclaimerSection",
  "isDarkBackground": "ekO5ga_isDarkBackground",
  "paddingBottom0": "ekO5ga_paddingBottom0",
  "paddingBottom112": "ekO5ga_paddingBottom112",
  "paddingBottom128": "ekO5ga_paddingBottom128",
  "paddingBottom16": "ekO5ga_paddingBottom16",
  "paddingBottom32": "ekO5ga_paddingBottom32",
  "paddingBottom48": "ekO5ga_paddingBottom48",
  "paddingBottom64": "ekO5ga_paddingBottom64",
  "paddingBottom80": "ekO5ga_paddingBottom80",
  "paddingBottom96": "ekO5ga_paddingBottom96",
  "paddingTop0": "ekO5ga_paddingTop0",
  "paddingTop112": "ekO5ga_paddingTop112",
  "paddingTop128": "ekO5ga_paddingTop128",
  "paddingTop16": "ekO5ga_paddingTop16",
  "paddingTop32": "ekO5ga_paddingTop32",
  "paddingTop48": "ekO5ga_paddingTop48",
  "paddingTop64": "ekO5ga_paddingTop64",
  "paddingTop80": "ekO5ga_paddingTop80",
  "paddingTop96": "ekO5ga_paddingTop96",
});
